(() => {
  const html = document.documentElement;
  const ready = (result) => {
    html.dataset.easRegionState = "ready";
    html.dataset.easRegionResult = result;
  };
  const legacy = /^\/en-(?:ke|ma|tz|ug|zm|zw)(?=\/|$)/i;
  const cleanPath = window.location.pathname.replace(legacy, "") || "/";
  if (cleanPath !== window.location.pathname) {
    window.location.replace(cleanPath + window.location.search + window.location.hash);
    return;
  }
  const form = document.getElementById("EasAutomaticLocalization");
  const config = form?.querySelector("[data-eas-current-country]");
  if (!form || !config || window.Shopify?.designMode || document.getElementById("EasEditorLocalization")) {
    ready("native");
    return;
  }
  const current = config.dataset.easCurrentCountry;
  const supported = config.dataset.easSupportedCountries.split(",");
  const now = Date.now();
  const cacheKey = "eas-region-checked-v1";
  const attemptKey = "eas-region-attempt-v1";
  const read = (key) => {
    try { return JSON.parse(sessionStorage.getItem(key) || "null"); } catch { return null; }
  };
  const write = (key, value) => {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
  };
  const cached = read(cacheKey);
  if (cached?.country === current && now - cached.at < 300000) {
    ready("confirmed");
    return;
  }
  const attempt = read(attemptKey);
  if (attempt?.country === current && now - attempt.at < 60000) {
    write(cacheKey, {country: current, at: now});
    ready("localized");
    return;
  }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 2500);
  fetch("/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=" + encodeURIComponent(current), {
    credentials: "same-origin", signal: controller.signal, headers: {Accept: "application/json"}
  }).then(response => {
    if (!response.ok) throw new Error("Location unavailable");
    return response.json();
  }).then(data => {
    const detected = data?.detected_values?.country?.handle;
    if (!supported.includes(detected)) { ready("native"); return; }
    if (detected === current) {
      write(cacheKey, {country: current, at: now});
      ready("matched");
      return;
    }
    if (attempt?.country === detected && now - attempt.at < 60000) {
      ready("native");
      return;
    }
    if (!write(attemptKey, {country: detected, at: now})) { ready("native"); return; }
    form.elements.namedItem("country_code").value = detected;
    form.elements.namedItem("return_to").value = cleanPath + window.location.search + window.location.hash;
    html.dataset.easRegionResult = "switching";
    form.submit();
  }).catch(() => ready("native")).finally(() => clearTimeout(timeout));
})();